<template>
  <div class="slider-wrapper">
    <!-- メインスライダー -->
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :loop="true"
      :thumbs="{ swiper: thumbsSwiper }"
      navigation
      :pagination="{ clickable: true }"
      @swiper="onMainSwiper"
      class="main-swiper"
    >
      <swiper-slide v-for="(item, index) in list" :key="'main-' + index">
        <img :src="item.pic" alt="main image" />
      </swiper-slide>
    </swiper>

    <!-- サムネイルスライダー -->
    <swiper
      :modules="modules"
      :slides-per-view="5"
      :space-between="10"
      watchSlidesProgress
      @swiper="onThumbsSwiper"
      class="thumbs-swiper"
    >
      <swiper-slide v-for="(item, index) in list" :key="'thumb-' + index">
        <img :src="item.pic" alt="thumbnail" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<style lang="scss" scoped>
.slider-wrapper {
  .main-swiper {
    width: 100%;
    .swiper-slide{
      padding: calc(100% / 16 * 8) 0 0;
      position: relative;
      background: $white;
      border-radius: .4rem;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center center;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  .thumbs-swiper {
    margin: 2.4rem 0 0;
    .swiper-slide{
      height: 8rem;
      border-radius: .4rem;
      overflow: hidden;
      position: relative;
      background: $white;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: relative;
      cursor: pointer;
      opacity: 0.5;
      transition: opacity 0.3s ease;
    }
    .swiper-slide-thumb-active img {
      opacity: 1;
    }
  }
}
</style>

<script>
import { Navigation, Pagination, Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref } from 'vue'

export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const thumbsSwiper = ref(null)

    const onMainSwiper = () => {}
    const onThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper
    }

    return {
      onMainSwiper,
      onThumbsSwiper,
      thumbsSwiper,
      modules: [Navigation, Pagination, Thumbs],
    }
  },
}
</script>
